/**
 * Sticky polyfill for IE
 */
$(document).ready (function () {
    if ($(".browser_ms-ie").length && $("[data-sticky-sidebar='is-sticky']").length) {
        stickybits("[data-sticky-sidebar='is-sticky']", {
            // offset in pixels
            stickyBitStickyOffset: 226
        });
    }
});